import { Service } from "./Service.js";

export class VolumeService extends Service {
  /**
   * @type {boolean} if user has muted videos, true by default because
   * we can't autoplay videos with audio due to browser limitations
   */
  #mutedInternal = true;

  get muted() {
    return this.#mutedInternal;
  }

  get unmuted() {
    return !this.#mutedInternal;
  }

  unmute() {
    this.#mutedInternal = false;
  }

  mute() {
    this.#mutedInternal = true;
  }
}
